import { getGuid } from "owa-guid";

// Unlike a session ID, this is more like an instance ID for each page refresh
export const PLACES_TELEMETRY_TRACKING_ID: string = getGuid();

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function now called at module scope is not allowed. This may cause unwanted side effects. */
export const PLACES_APP_START_TIME: number = performance.now();
